<template>
  <div class="box1">
    <div class="titleWrap">
      <div class="title"></div>
      <div class="content">AI赋能软件测试，提升测试效率、准确性和覆盖率</div>
      <img class="text-pic" src="../../../assets/coursePage/softwareTest/box1/text-pic.png" />
    </div>
    <vue-seamless-scroll
      :data="tabList"
      :class-option="classOptionbox1"
      class="seamless-warp"
    >
      <div class="demo">
        <div class="item" v-for="(item, index) in tabList" :key="index">
          <p>
            {{ item.tit }}<i>{{ item.titSpec }}</i>
          </p>
          <b>{{ item.txt }}</b>
        </div>
      </div>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      tabList: [
        {
          tit: "AI引领",
          titSpec: "编程测试",
          txt: "编程测试为主，让工作更简单",
        },
        { tit: "技术更新", titSpec: "教育创新", txt: "紧跟技术迭代，技能领先一步" },
        { tit: "上手简单", titSpec: "学完就业", txt: "跨行、零基础无压力，仅需120天" },
        { tit: "实战为王", titSpec: "技能为先", txt: "课程闭环嵌套，学即是战" },
      ],
    };
  },

  computed: {
    classOptionbox1() {
      return {
        step: 0.4, // 数值越大速度滚动越快
        limitMoveNum: 4, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
};
</script>

<style lang="less" scoped>
.box1 {
  position: relative;
  padding-bottom: 60px;
  width: 100%;
  background: url("../../../assets/coursePage/softwareTest/box1/bg.png")
    no-repeat;
  background-size: auto 600px;
  background-position: top center;
  overflow: hidden;
  box-sizing: border-box;
  .titleWrap {
    padding-top: 40px;
  }
  .title {
    width: 552px;
    height: 130px;
    background: url("../../../assets/coursePage/softwareTest/box1/title.png")
      no-repeat;
    background-size: contain;
    background-position: left center;
  }
  .content {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #002e77;
    margin: 10px 42px 40px;
  }
  .text-pic {
    display: block;
    width: 228px;
    margin-left: 44px;
  }
  .seamless-warp {
    margin-top: 48px;
    width: 750px !important;
    padding-left: 11px;
    overflow: hidden;
    .demo {
      display: flex;
    }
    .item {
      width: 512px;
      height: 188px;
      background: url("../../../assets/coursePage/softwareTest/box1/bg2.png")
        no-repeat;
      background-size: 100% 100%;
      background-position: center;
      padding: 42px 0 0 134px;
      flex-shrink: 0;
      box-sizing: border-box;
      margin-left: 10px;
      p {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #002053;
        line-height: 40px;
        margin-bottom: 14px;
        i {
          font-weight: 600;
          font-style: normal;
          margin-left: 10px;
        }
      }
      b {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #68778f;
        line-height: 34px;
      }
    }
  }
}
</style>
